import(/* webpackMode: "eager" */ "/opt/buildhome/repo/frontend/src/app/[locale]/error.tsx");
